module.exports = __webpack_public_path__ + "img/easter_egg_modal_cover_found_all.3d052a2e.png";